import BodyColumnData, {
  BodyColumnValue,
} from "../../components/NotificationsScreen/BodyColumnData.model";

interface Values {
  [key: string]: any;
}

const collectValuesFromRow = (row: BodyColumnData[]): Values => {
  const rowValues: Values = {};

  row.forEach((column) => {
    const columnData = column?.data;
    if (Array.isArray(columnData)) {
      columnData.forEach((item: BodyColumnValue) => {
        const referenceKey = item.uiKey ?? item.key;
        rowValues[referenceKey] = item.value;
        rowValues[`${referenceKey}_DISABLED`] = item.disabled;
      });
    }
  });

  return rowValues;
};

export const getFilteredValues = (
  tableBody: Array<BodyColumnData[]>
): Values[] => {
  const values = tableBody.map(collectValuesFromRow);

  return values.filter((item) => {
    const keys = Object.keys(item).filter((key) => !key.endsWith("_DISABLED"));
    return keys.length > 0 && !keys.every((key) => item[`${key}_DISABLED`]);
  });
};
